import React, { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import AccessManagementAuthorizer from './components/AccessManagementAuthorizer';

const RolesPage = lazy(() => import('./pages/roles/RolesPage'));
const PermissionsPage = lazy(() => import('./pages/permissions/PermissionsPage'));
const UsersPage = lazy(() => import('./pages/users/UsersPage'));
const UserDetailsPage = lazy(() => import('./pages/user-details/UserDetailsPage'));

const routes: RouteObject[] = [
  {
    element: <AccessManagementAuthorizer />,
    children: [
      {
        path: '/admin/access-management',
        element: <Navigate to='/admin/access-management/roles' replace />
      },
      {
        path: '/admin/access-management/roles',
        element: <RolesPage />
      },
      {
        path: '/admin/access-management/permissions',
        element: <PermissionsPage />
      },
      {
        path: '/admin/access-management/users',
        element: <UsersPage />
      },
      {
        path: '/admin/access-management/users/:userId',
        element: <UserDetailsPage />
      }
    ]
  }
];

export default routes;
